import React from 'react';

import ExportButton from '../../controls/maintenance/member/ExportButton';

const MemberExportSection = (props) => {
  return <ExportButton />;
};

export default MemberExportSection;
